import { useEffect, useState } from 'react';
import { setupScripts } from './globalDefinitions';

/**
 * hook to get environment name
 * We can't use the staging setting unitil we know the MIP team enables
 * every single form used by the widgets from thh staging environment.
 * /*
 * @info: use
 * `$SME$ test`
 * for Company name to prevent creating official IBM CI
 *
 * @returns {string} environment
 */

export enum environment {
  production = 'production',
  stage = 'stage',
  preview = 'preview',
}

export const useEnv = (): [string] => {
  const [env, setEnv] = useState(environment.preview);

  useEffect(() => {
    if (window.location.host === 'www.ibm.com') {
      setEnv(environment.production);
    }
    if (window.location.hostname === 'localhost') {
      console.log(`Setting stage:`, window.location.hostname);
      setEnv(environment.stage);
      setupScripts(
        'https://wwwstage.ibm.com/account/ibmidutil/widget/js/main.js',
        'https://wwwstage.ibm.com/account/ibmidutil/widget/js/loader.js',
      );
    }
  }, []);
  return [env];
};
